import { useLayoutEffect, useRef, memo } from 'react';
import { Collapse } from 'bootstrap';
import { Link } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { MASTER_LOGIN, PAGE_URLS, LOCAL_STORAGE_USER_DATA } from '../constants';
import hiveDeskLogoWhite from '../assets/img/logo-white.png';
import hiveDeskLogo from '../assets/img/logo.png';
import MyAccountDropdown from './MyAccountDropdown';
import OnboardingProgress from './OnboardingProgress';

const Navigation = ({ category }) => {
  const collapses = document.querySelectorAll('.navbar-nav .collapse');

  collapses.forEach((collapse) => {
    // Init collapses
    const collapseInstance = new Collapse(collapse, {
      toggle: false,
    });

    // Hide sibling collapses on `show.bs.collapse`
    collapse.addEventListener('show.bs.collapse', (e) => {
      e.stopPropagation();

      const closestCollapse = collapse.parentElement.closest('.collapse');
      const siblingCollapses = closestCollapse.querySelectorAll('.collapse');

      siblingCollapses.forEach((siblingCollapse) => {
        const siblingCollapseInstance = Collapse.getInstance(siblingCollapse);

        if (siblingCollapseInstance === collapseInstance) {
          return;
        }

        siblingCollapseInstance.hide();
      });
    });

    // Hide nested collapses on `hide.bs.collapse`
    collapse.addEventListener('hide.bs.collapse', (e) => {
      e.stopPropagation();

      const childCollapses = collapse.querySelectorAll('.collapse');

      childCollapses.forEach((childCollapse) => {
        const childCollapseInstance = Collapse.getInstance(childCollapse);

        childCollapseInstance.hide();
      });
    });
  });
  const ref = useRef(null);
  useLayoutEffect(() => {
    ref.current.style.setProperty('margin-top', '100%', '!important');
  }, []);
  const userDetails = useSelector((state) => state.userReducer);
  const userData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA));
  const billingDetails = useSelector((state) => state.billingReducer);
  const currentPlan = (
    (userDetails &&
      userDetails.subscription.currentPlan !== null &&
      userDetails.subscription.currentPlan) ||
    ''
  ).toLowerCase();
  const { accountStatus } = billingDetails;
  const isFreeTrial =
    (currentPlan === 'trial' && accountStatus !== 'cancel') || false;
  const isMasterPassword =
    sessionStorage.getItem(MASTER_LOGIN) === 'true' || false;
  const isTimesheetApproval = useSelector((state) => state.timesheetApproval);
  return (
    <Navbar
      collapseOnSelect
      expand="md"
      id="sidebar"
      className={
        isFreeTrial && userDetails.role !== 'member'
          ? 'navbar-vertical fixed-left free-trial'
          : 'navbar-vertical fixed-left'
      }
    >
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Brand href="#home">
        <img
          src={hiveDeskLogoWhite}
          alt="HiveDesk"
          className="d-none d-md-block"
        />
        <img src={hiveDeskLogo} alt="HiveDesk" className="d-block d-md-none" />
      </Navbar.Brand>
      <span className="d-block d-sm-none">
        <MyAccountDropdown />
      </span>
      <Navbar.Collapse id="basic-navbar-nav">
        <ul className="navbar-nav">
          {userDetails.role !== 'member' && (
            <li className="nav-item">
              <Link to={PAGE_URLS.DASHBOARD} className="nav-link">
                <i className="mdi mdi-view-dashboard" /> Dashboard
              </Link>
            </li>
          )}
          {userDetails.role === 'creator' && (
            <li className="nav-item">
              <Link to={PAGE_URLS.CLIENTS} className="nav-link">
                <i className="mdi mdi-account-multiple-outline" /> Clients
              </Link>
            </li>
          )}
          <li className="nav-item nav-projects">
            <a
              className="nav-link"
              href="#projects"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded={category === 'Projects'}
              aria-controls="projects"
            >
              <i className="mdi mdi-folder-open" /> Projects
            </a>
            <div
              className={category === 'Projects' ? 'collapse show' : 'collapse'}
              id="projects"
            >
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link to={PAGE_URLS.PROJECTS.ACTIVE} className="nav-link ">
                    Active
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/projects/archived" className="nav-link ">
                    Archived
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          {userDetails.role !== 'member' && (
            <li className="nav-item nav-team">
              <a
                className="nav-link"
                href="#team"
                data-bs-toggle="collapse"
                role="button"
                aria-expanded={category === 'Team'}
                aria-controls="projects"
              >
                <i className="mdi mdi-account-group-outline" /> Team
              </a>
              <div
                className={category === 'Team' ? 'collapse show' : 'collapse'}
                id="team"
              >
                <ul className="nav nav-sm flex-column">
                  <li className="nav-item">
                    <Link to={PAGE_URLS.TEAM.ACTIVE} className="nav-link ">
                      Active
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/team/inactive" className="nav-link ">
                      Inactive
                    </Link>
                  </li>
                </ul>
              </div>
            </li>
          )}
          <li className="nav-item nav-timesheet">
            <a
              className="nav-link"
              href="#timesheet"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded={category === 'Timesheet'}
              aria-controls="timesheet"
            >
              <i className="mdi mdi-folder-clock-outline" /> Timesheet
            </a>
            <div
              className={
                category === 'Timesheet' ? 'collapse show' : 'collapse'
              }
              id="timesheet"
            >
              <ul className="nav nav-sm flex-column">
                {isTimesheetApproval && (
                  <>
                    <li className="nav-item">
                      <Link to="/timesheet/view" className="nav-link ">
                        View
                      </Link>
                    </li>
                    {(userDetails.role === 'creator' ||
                      userDetails.role === 'full_manager') && (
                      <li className="nav-item">
                        <Link to="/timesheet/approval" className="nav-link ">
                          Approval
                        </Link>
                      </li>
                    )}
                  </>
                )}
                <li className="nav-item">
                  <Link to="/timesheet/detailed" className="nav-link ">
                    Detailed timesheet
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/timesheet/summarized" className="nav-link ">
                    Summarized timesheet
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item nav-activity">
            <a
              className="nav-link"
              href="#activity"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded={category === 'Activity'}
              aria-controls="activity"
            >
              <i className="mdi mdi-clipboard-pulse-outline" /> Activity
            </a>
            <div
              className={category === 'Activity' ? 'collapse show' : 'collapse'}
              id="activity"
            >
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link to={PAGE_URLS.ACTIVITY.MEMBER} className="nav-link ">
                    Member Activity
                  </Link>
                </li>
                {userDetails.role !== 'member' && (
                  <li className="nav-item">
                    <Link to={PAGE_URLS.ACTIVITY.TEAM} className="nav-link ">
                      Team Activity
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              href="#reports"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded={category === 'Reports'}
              aria-controls="reports"
            >
              <i className="mdi mdi-file-document-box-multiple-outline" />{' '}
              Reports
            </a>
            <div
              className={category === 'Reports' ? 'collapse show' : 'collapse'}
              id="reports"
            >
              <ul className="nav nav-sm flex-column">
                {userDetails.role !== 'member' && (
                  <li className="nav-item">
                    <Link to="/reports/screenshot" className="nav-link ">
                      Screenshot report
                    </Link>
                  </li>
                )}
                <li className="nav-item">
                  <Link to="/reports/charts" className="nav-link ">
                    Charts
                  </Link>
                </li>
              </ul>
            </div>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              href="#settings"
              data-bs-toggle="collapse"
              role="button"
              aria-expanded={category === 'Settings'}
              aria-controls="settings"
            >
              <i className="mdi mdi-shield-account-outline" /> Settings
            </a>
            <div
              className={category === 'Settings' ? 'collapse show' : 'collapse'}
              id="settings"
            >
              <ul className="nav nav-sm flex-column">
                <li className="nav-item">
                  <Link to="/settings/general" className="nav-link ">
                    General
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/settings/password" className="nav-link ">
                    Password
                  </Link>
                </li>
                {userDetails.role === 'creator' && (
                  <li className="nav-item">
                    <Link to="/settings/billing" className="nav-link ">
                      Billing
                    </Link>
                  </li>
                )}
                <li className="nav-item">
                  <Link to="/settings/teams" className="nav-link ">
                    Teams
                  </Link>
                </li>
                {userDetails.role !== 'member' && (
                  <li className="nav-item">
                    <Link to="/settings/email-summaries" className="nav-link ">
                      Email summaries
                    </Link>
                  </li>
                )}
                {userDetails.role === 'creator' && (
                  <li className="nav-item">
                    {userData &&
                    userData.integrations &&
                    userData.integrations.length > 0 ? (
                      <Link
                        to="/settings/integration-status"
                        className="nav-link "
                      >
                        Integration Details
                      </Link>
                    ) : (
                      <Link
                        to="/settings/integration-list"
                        className="nav-link "
                      >
                        Integrations
                      </Link>
                    )}
                  </li>
                )}
              </ul>
            </div>
          </li>
          {isFreeTrial && userDetails.role !== 'member' && (
            <OnboardingProgress />
          )}
        </ul>
        <div className="mt-auto" ref={ref} />
        {isMasterPassword && (
          <ul className="navbar-nav">
            <li className="nav-item">
              <Link to="/changelog" className="nav-link">
                <i className="mdi mdi-clock-alert-outline" /> Changelog
                <span
                  className=" badge bg-primary capitalize"
                  style={{ marginLeft: '.3rem' }}
                >
                  v4.1.5
                </span>
              </Link>
            </li>
          </ul>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

Navigation.propTypes = {
  category: PropTypes.string,
};

export default memo(Navigation);
